import React, { useState, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';
import CollapsibleContent from './collapsible-content';

const CollapsibleSection = ({ title, collapsedIcon, expandedIcon, collapsedDefault, children }) => {
  const [collapsed, setCollapsed] = useState(collapsedDefault);

  return (
    <section className="collapsible-section">
      <h4 className="cursor-pointer" onClick={() => setCollapsed(collapsed => !collapsed)}>
        {collapsed ? collapsedIcon : expandedIcon} {title}
      </h4>

      <CollapsibleContent collapsed={collapsed}>{children}</CollapsibleContent>
    </section>
  );
};

CollapsibleSection.propTypes = {
  title: PropTypes.string.isRequired,
  collapsedIcon: PropTypes.node,
  expandedIcon: PropTypes.node,
  collapsedDefault: PropTypes.bool,
  children: PropTypes.node.isRequired
};

CollapsibleSection.defaultProps = {
  collapsedIcon: '+',
  expandedIcon: '-',
  collapsedDefault: false
};

export default CollapsibleSection;
